import produce from 'immer';
import {
  LEVELUPLOG_LIST_REQUEST, LEVELUPLOG_LIST,
  SET_TOTAL_COUNT, SET_LEVELUPLOG_PAGINATION, LEVELUPLOG_PAGE_RESET,
} from '../../constants/log/levelUpLogConstants';
import moment from 'moment';

const initialState = {
  page: 1,
  pageLength: 10,
  beginDate: moment().utc().subtract(3, 'days').format('YYYY-MM-DDT00:00:00'),
  endDate: moment().utc().format('YYYY-MM-DDT23:59:59'),
  searchCode: '',
  searchString: '',
  totalCount: 0,
};

const levelUpLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case LEVELUPLOG_LIST_REQUEST:
      break;
    case LEVELUPLOG_LIST:
      draft.list = action.list;
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_LEVELUPLOG_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.beginDate = action.beginDate;
      draft.endDate = action.endDate;
      draft.searchCode = action.searchCode;
      draft.searchString = action.searchString;
      break;
    case LEVELUPLOG_PAGE_RESET:
      draft.page = 1;
      break;
    default:
      break;
  }
});

export default levelUpLogReducer;
